import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Divider
} from '@mui/material'

const FirmSelectionConfirmDialog = ({
  open,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation()
  const [userPrompt, setUserPrompt] = useState('')
  const inputRef = useRef(null)

  const handleEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleCancel = () => {
    setUserPrompt('')
    onCancel()
  }

  const handleConfirm = () => {
    onConfirm(userPrompt)
    setUserPrompt('')
  }

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      TransitionProps={{
        onEntered: handleEntered
      }}
    >
      <DialogTitle>
        {t('mailTemplate.wizard.firmSelectionConfirm.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('mailTemplate.wizard.firmSelectionConfirm.message')}
        </DialogContentText>
        <Divider sx={{ my: 2, borderColor: 'grey.800' }} />
        <DialogContentText sx={{ mb: 2 }}>
          {t('mailTemplate.wizard.firmSelectionConfirm.relevanceInfo')}
        </DialogContentText>
        <TextField
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          size="small"
          inputRef={inputRef}
          label={t('mailTemplate.wizard.firmSelectionConfirm.userPromptLabel')}
          placeholder={t('mailTemplate.wizard.firmSelectionConfirm.userPromptPlaceholder')}
          value={userPrompt}
          onChange={(e) => setUserPrompt(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          {t('mailTemplate.wizard.firmSelectionConfirm.cancel')}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          {t('mailTemplate.wizard.firmSelectionConfirm.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FirmSelectionConfirmDialog
